import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getExpenseType, getExpenseTypes, postExpenseType, putExpenseType } from '../../../store/actions/expense_type/expense_type_action';
import { REACT_ROUTES } from '../../../constants/react_routes';
import history from '../../../services/history';
import TextInput from '../../ui_components/text_input';
import { useSnackbar } from 'notistack';
import { EXPENSE_TYPE_TAB } from '../../../constants/constants';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    typography: {
		margin: theme.spacing(3, 0, 2)
    },
    form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	}
}));

const ExpenseType = ({ expenseTypes }) => {
    const { uuid } = useParams();
    const { container, typography, form } = useStyles();
    const { control, handleSubmit, setValue, formState: { errors } } = useForm();
    const dispatch = useDispatch();

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        uuid && (async () => {
            const expenseType = await getExpenseType(uuid);
            for (const key in expenseType) {
                setValue(key, expenseType[key]);
            }
        })();
        !expenseTypes.collection.length && dispatch(getExpenseTypes());
    }, [uuid]);

    const onSubmit = (data) => {
        if (uuid) {
            enqueueSnackbar(
                'Uspešno ste izmenili tip troška', {
                variant: 'success'
            });
            return dispatch(putExpenseType(uuid, data));
        }
        enqueueSnackbar(
            'Uspešno ste sačuvali tip troška', {
            variant: 'success'
        });
        return dispatch(postExpenseType(data));
    }

    const handleClickBackToTabs = () => {
        history.push(REACT_ROUTES.EXPENSE_TABS, { selectedTab: EXPENSE_TYPE_TAB });
    }

    return (
        <Container className={container}>
            <Typography align="center" variant="h4" className={typography}>Tip troška</Typography>
            <Grid container justify="center" spacing={3}>
                <Grid item>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        type="button"
                    >
                        Sačuvaj
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleClickBackToTabs}
                    >
                        Nazad
                    </Button>
                </Grid>
            </Grid>
            <form className={form}>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={8}>
                        <TextInput
                            control={control}
                            name="name"
                            label="Naziv"
                            rules={{ required: 'Unesite naziv' }}
                        />
                        <ErrorMessage errors={errors} name="name" as="p" />
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

ExpenseType.propTypes = {
    expenseTypes: PropTypes.object
}

const mapStateToProps = (state) => ({
    expenseTypes: state.expenseTypes
});

export default connect(mapStateToProps)(ExpenseType);
